import { FunctionComponent, PropsWithChildren } from "react";

import * as Styled from "./styles";
import { COLOR_MANIFEST_TEAL } from "../../styles/globalStylesVariables";

interface HighlightProps extends PropsWithChildren {
  color?: string;
  name?: string;
}

const Highlight: FunctionComponent<HighlightProps> = ({ name = undefined, color = COLOR_MANIFEST_TEAL, children }) => {
  return (
    <Styled.HighlightText $color={color} data-name={name}>
      {children}
    </Styled.HighlightText>
  );
};

export default Highlight;
